import { router } from "@inertiajs/react"

import { signInPath } from "@/routes"

const DEMO_EMAIL = "demo@batyr.com.au"
const DEMO_PASSWORD = "Password1!23"

export function QuickLoginPanel() {
  if (
    import.meta.env.VITE_QUICK_LOGIN !== "true" &&
    import.meta.env.MODE === "production"
  )
    return null

  const handleSignIn = () => {
    // Set input values via DOM so FormData picks them up if needed,
    // then submit directly via Inertia router.
    const emailInput = document.querySelector<HTMLInputElement>(
      'input[name="email"]',
    )
    const passwordInput = document.querySelector<HTMLInputElement>(
      'input[name="password"]',
    )

    if (emailInput) emailInput.value = DEMO_EMAIL
    if (passwordInput) passwordInput.value = DEMO_PASSWORD

    router.post(signInPath(), { email: DEMO_EMAIL, password: DEMO_PASSWORD })
  }

  return (
    <div className="fixed right-4 bottom-4 z-50 w-80 rounded-lg bg-gray-900/90 text-xs text-gray-200 shadow-lg backdrop-blur">
      <div className="flex flex-col gap-2 px-3 py-3">
        <div className="flex items-center gap-1.5 font-medium">
          <span>Quick Login</span>
        </div>
        <div className="text-gray-400">
          <span className="font-medium text-gray-200">Demo User</span>
          <br />
          {DEMO_EMAIL} / {DEMO_PASSWORD}
        </div>
        <button
          type="button"
          onClick={handleSignIn}
          className="bg-brand-600 hover:bg-brand-700 mt-1 w-full rounded-md px-3 py-1.5 text-xs font-medium text-white"
        >
          Sign in as Demo User
        </button>
      </div>
    </div>
  )
}
